<div class="container-fluid p-4 pt-0">
  <!-- Export Row -->
  <div class="row mb-3">
    <div class="col-12">
      <div class="d-flex justify-content-end">
        <button
          kendoButton
          (click)="pdf.saveAs('vss-dashboard.pdf')"
          themeColor="primary"
          size="small"
          class="vss-export-icon-btn"
          title="Export to PDF"
          [svgIcon]="exportIcon"
        ></button>
      </div>
    </div>
  </div>

  <kendo-pdf-export
    #pdf
    paperSize="A4"
    [landscape]="true"
    margin="1cm"
    [scale]="0.6"
    forcePageBreak=".page-break"
    [imageResolution]="300"
  >
    <!-- Top row - Combined Vulnerability Overview and Aging Analysis -->
    <div class="row g-3 mb-2">
      <!-- Left column - Vulnerabilities detected -->
      <div class="col-lg-6 mb-2">
        <app-vulnerability-overview
         [vssOverviewDataResponse]="vssOverviewDataResponse()"
         [organizationId]="organizationId"
         ></app-vulnerability-overview>
      </div>
      <!-- Right column - Critical Vulnerability Aging Analysis -->
      <div class="col-lg-6 mb-2">
        <app-critical-vulnerability-aging
          [criticalVulnerabilityAgingResponse]="criticalVulnerabilityAgingResponse()"
          [organizationId]="organizationId"
        ></app-critical-vulnerability-aging>
      </div>
    </div>
    <!-- Vulnerability Aging Analysis and Problem Child Patches -->
    <div class="row mb-2">
      <!-- Problem Child Patches -->
      <div class="col-lg-12 mb-2">
        <app-problem-child-patches
          [problemChildPatchesResponse]="problemChildPatchesResponse()"
          [filters]="problemChildFilters()"
        ></app-problem-child-patches>
      </div>
    </div>
    <div class="page-break"></div>
    <!-- filter row -->
    <div class="row mb-2">
      <app-filter-header
        [timeRanges]="timeRanges"
        [selectedTimeRange]="selectedTimeRange"
        [startDate]="startDate || null"
        [endDate]="endDate || null"
        (onTimeRangeChange)="onTimeRangeChange($event)"
        (onStartDateChange)="onStartDateChange($event)"
        (onEndDateChange)="onEndDateChange($event)"
        (onApplyFilters)="applyFilters()"
      ></app-filter-header>
    </div>
    <!-- Time Series Metrics -->
    <div class="row mb-2">
      <div class="col-12 dashboard-metrics">
        <app-vss-coverage-card 
          [averageCoverageResponse]="averageCoverageResponse()"
          [organizationId]="organizationId"
          [startDate]="startDateString"
          [endDate]="endDateString"
        ></app-vss-coverage-card>
        <app-vss-compliance-card 
        [averageComplianceResponse]="averageComplianceResponse()"
        [organizationId]="organizationId"
        [startDate]="startDateString"
        [endDate]="endDateString"
        ></app-vss-compliance-card>
        <app-vss-mttm-card
          [averageMeanTimeToMitigateResponse]="averageMeanTimeToMitigateResponse()"
          [organizationId]="organizationId"
          [startDate]="startDateString"
          [endDate]="endDateString"
        ></app-vss-mttm-card>
      </div>
    </div>

    <div class="row g-3 mb-2">
      <!-- Vulnerability Events Detected vs Mitigated -->
      <div class="col-lg-6 mb-2">
        <app-vulnerability-events-chart
          [vulnerabilityEventsResponse]="vulnerabilityEventsResponse()"
          [organizationId]="organizationId"
          [startDate]="startDateString"
          [endDate]="endDateString"
        ></app-vulnerability-events-chart>
      </div>
      <!-- Scan Segmentation Analysis -->
      <div class="col-lg-6 mb-2">
        <app-device-type-chart
          [deviceTypeChartResponse]="deviceTypeChartResponse()"
          [organizationId]="organizationId"
          [startDate]="startDateString"
          [endDate]="endDateString"
        ></app-device-type-chart>
      </div>
    </div>
    <div class="page-break"></div>
    <!-- Critical & High Severity MTTR Analysis -->
     <div class="row mb-2">
      <div class="col-lg-12 mb-2">
        <app-mttm-analysis
          [mttmAnalysisResponse]="mttmAnalysisResponse()"
          [slaTargetsResponse]="slaTargetsResponse()"
          [organizationId]="organizationId"
          [startDate]="startDateString"
          [endDate]="endDateString"
          (onSLAEdit)="startSLAEdit($event.type)"
          (onSLASave)="saveSLA('both')"
          (onSLACancel)="cancelSLAEdit($event.type)"
        ></app-mttm-analysis>
      </div>
    </div>
  </kendo-pdf-export>

  <!-- SLA Dialog -->
   <app-sla-dialog
    [isVisible]="editingSLA.critical || editingSLA.high"
    [slaValues]="tempSLAValues"
    (onSave)="saveSLA('both')"
    (onCancel)="cancelSLAEdit('both')"
  ></app-sla-dialog>
</div>
